// Times for scheduled posts. The form works with datetime-local values
// ('YYYY-MM-DDTHH:mm', local time); the server wants an ISO time.

// the server posts at once when less than this is left
export const MIN_SCHEDULE_MS = 5 * 60 * 1000
// one more minute, so a time picked now is still valid when sent
const MARGIN_MS = 60 * 1000

const pad = (n) => String(n).padStart(2, '0')

export const toLocalInput = (date) =>
  `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}` +
  `T${pad(date.getHours())}:${pad(date.getMinutes())}`

export const earliestSchedule = (now = new Date()) =>
  toLocalInput(new Date(now.getTime() + MIN_SCHEDULE_MS + MARGIN_MS))

// an hour ahead, on a five-minute step: where a new schedule starts
export const defaultSchedule = (now = new Date()) => {
  const step = 5 * 60 * 1000
  return toLocalInput(
    new Date(Math.ceil((now.getTime() + 60 * 60 * 1000) / step) * step),
  )
}

// null when the time can be used, else 'invalid' or 'too_soon'
export const scheduleProblem = (value, now = new Date()) => {
  const time = new Date(value).getTime()
  if (!value || Number.isNaN(time)) return 'invalid'
  return time - now.getTime() > MIN_SCHEDULE_MS ? null : 'too_soon'
}

// the message for a problem from scheduleProblem
export const scheduleProblemKey = (problem) =>
  problem === 'too_soon'
    ? 'post_status.schedule_too_soon'
    : 'post_status.schedule_invalid'

export const formatScheduleTime = (iso, locale) =>
  new Date(iso).toLocaleString(locale, {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  })

// 'in 30 minutes', 'in 3 hours', 'in 2 days'
export const timeUntil = (iso, now = new Date(), locale) => {
  const minutes = Math.round((new Date(iso).getTime() - now.getTime()) / 60e3)
  const format = new Intl.RelativeTimeFormat(locale, { numeric: 'auto' })
  if (Math.abs(minutes) < 60) return format.format(minutes, 'minute')
  const hours = Math.round(minutes / 60)
  if (Math.abs(hours) < 48) return format.format(hours, 'hour')
  return format.format(Math.round(hours / 24), 'day')
}
